<template>
  <div class="w-100 h-100 m-0" style="padding: 40px; background: #F5F7FA;">
    <div class="d-flex flex-column align-items-center" style="gap: 32px;">
      <div class="m-0 p-0 d-flex acry-page-title justify-content-center" style="gap:8px;">
        <img src="@/assets/acrypro/coupon/step4.svg" />
        <div>イベント内容と決済</div>
      </div>

      <div class="d-flex flex-column justify-content-center" style="width: 1046px; background:#FFFFFF; padding:24px; gap:16px;">
        <div class="text-main-color fw-bold">
          イベント内容
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>ご注文枚数</div>
          <div class="ms-auto">{{this.$store.state.acrylicTicketCouponManager.orderData.count}}</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>送料負担</div>
          <div v-if="this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee" class="ms-auto">チケット使用者負担</div>
          <div v-else class="ms-auto">チケット発行者負担</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>チケット使用者編集</div>
          <div v-if="this.$store.state.acrylicTicketCouponManager.orderData.isUserEdit" class="ms-auto">可</div>
          <div v-else class="ms-auto">不可</div>
        </div>
        <div class="d-flex" style="height:325px; padding-bottom:8px;">
          <div>アクリルデザイン</div>
          <img class="ms-auto" style="width: 230px; object-fit: contain;" :src="this.$store.state.acrylicTicketCouponManager.orderData.preview" />
        </div>
      </div>

      <div class="d-flex flex-column justify-content-center" style="width: 1046px; background:#FFFFFF; padding:24px; gap:16px;">
        <div class="text-main-color fw-bold">
          決済内容
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>チケットコード代金</div>
          <div class="ms-auto">{{(ticketPrice).toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),}}</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0; color: #BC6665;">
          <div>割引金額</div>
          <div class="ms-auto">{{(-discount).toLocaleString("ja-JP", { style: "currency", currency: "JPY" }).replace(/^-(￥)/, "$1-")}}</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>送料代</div>
          <div class="ms-auto">{{delivPrice.toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),}}</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>消費税</div>
          <div class="ms-auto">{{totalTax.toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),}}</div>
        </div>
        <div class="d-flex text-main-color fw-bold" style="height:38px; padding-bottom:8px; font-size:20px;">
          <div>ご注文合計金額</div>
          <div class="ms-auto">{{totalPrice.toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),}}</div>
        </div>
      </div>

      <!-- <div class="d-flex flex-column justify-content-center" style="width: 1046px; background:#FFFFFF; padding:24px; gap:16px;">
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>お支払い方法</div>
          <div class="ms-auto">aaaaaaaa</div>
        </div>
        <div class="d-flex" style="height:30px; padding-bottom:8px; border-bottom: solid 1px #E0E0E0">
          <div>お支払い期限</div>
          <div class="ms-auto">aaaaaaaa</div>
        </div>
      </div> -->

      <div class="d-flex flex-column justify-content-center"
      style="width: 1046px; background:#FFF6F6; padding:24px; gap:16px; border-radius: 4px; border: solid 1px #BDBDBD;">
        <div class="text-main-color fw-bold" style="font-size: 28px;">
          確認事項
        </div>
        <div class="d-flex flex-column text-start" style="padding-bottom:8px;">
          <div>・発行したものについては払い戻しできませんので、ご注文内容をご確認いただいてからお支払いの程お願いいたします。</div>
          <div>・デザインに不備がある場合、弊社からご連絡させていただくことがあります。</div>
          <div>・質問などはお問い合わせから受け付けております。</div>
        </div>
      </div>

      <div class="d-flex justify-content-center" style="gap:32px;">
        <button class="mx-0 acry-btn-sub fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickReturnBtn">
          もどる
        </button>
        <button class="mx-0 acry-btn-sub fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickEstimatesBtn">
          見積書発行
        </button>
        <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickOrderBtn">
          お支払いへ
        </button>
      </div>
    </div>


    <!-- 購入完了モーダル -->
    <div v-if="isModal" class="modal-bg">
      <div class="d-flex flex-column" style="width: 850px; height: 330px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 40px;">
        <div class="fw-bold" style="font-size: 20px;">
          チケットコードが発行されました
        </div>
        <div style="font-size: 14px;">
          反映までお時間がかかる場合があります
        </div>
        <div style="font-size: 14px;">
          チケットコードが発行されました
        </div>
        <div class="d-flex justify-content-center" style="gap:40px;">
          <button class="m-0 acry-btn-sub fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px;" @click="onClickTicketList">
            チケット一覧
          </button>
          <button class="m-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px;" @click="onClickIssueHistory">
            発行コード履歴
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { GetAcryProductPrice, PaymentType, ProductId, AcryShippingFeeBase, AcryShippingFee, GetAcryProductSizeText } from "@/js/Const.js";
import { Common } from '@/js/common.js'
import { CalculationTicketOrderPrice } from "@/js/CommonFunc.js";
import { User } from "@/js/User.js";
import { CenterViewState } from "@/js/Const.js";
import { Analytics } from "@/js/Analytics.js";


export default {
  name: "CenterViewTicketOrderConfirm_Ap",
  props: {},
  data: function () {
    return {
      isModal: false,
      ticketPrice: 0,
      discount: 0,
      delivPrice: 0,
      totalTax: 0,
      totalPrice: 0,
    };
  },
  computed: {
    // ticketPrice(){
    //   const PriceData = GetAcryProductPrice(this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId);
    //   return PriceData.priceBase * this.$store.state.acrylicTicketCouponManager.orderData.count;
    // },
    // shippingFee(){
    //   if( this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee ){
    //     return 0;
    //   }else{
    //     return AcryShippingFeeBase * this.$store.state.acrylicTicketCouponManager.orderData.count;
    //   }
    // },
    // totalTax(){
    //   let tax = 0;

    //   // チケット
    //   const PriceData = GetAcryProductPrice(this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId);
    //   const TicketTax = PriceData.price - PriceData.priceBase;
    //   tax += TicketTax * this.$store.state.acrylicTicketCouponManager.orderData.count;

    //   // 送料
    //   if( !this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee ){
    //     const shippingTax = AcryShippingFee - AcryShippingFeeBase;
    //     tax += shippingTax * this.$store.state.acrylicTicketCouponManager.orderData.count;
    //   }
    //   return tax;
    // },
    // totalPrice(){
    //   return this.ticketPrice + this.shippingFee + this.totalTax;
    // }
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");

    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });

    const orderPrice = CalculationTicketOrderPrice(
      this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
      this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee,
      this.$store.state.acrylicTicketCouponManager.orderData.count,
      this.$store.state.acrylicTicketCouponManager.orderData.isSample
    );

    this.ticketPrice = orderPrice.ticketPrice;
    this.discount = orderPrice.discount;
    this.delivPrice = orderPrice.delivPrice;
    this.totalTax = orderPrice.totalTax;
    this.totalPrice = orderPrice.totalPrice;

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    async clickReturnBtn(){
      this.$store.commit("setCenterViewState", CenterViewState.EventTicketIssue);
    },
    async clickEstimatesBtn(){
      this.$store.commit("showLoading");

      let priceData = this.createProductPriceData();
      this.$store.commit("setEstimatesProductData", priceData.productList);

      // 配送先情報を設定
      // 配送先がないので顧客情報を設定
      // 登録されている住所の取得
      const userInfo = await User.getInfo().catch(() => {
        console.log("エラー");
      });

      let estimatesData = {
        zip01:userInfo.zip01,
        zip02:userInfo.zip02,
        addr01:userInfo.addr01,
        addr02:userInfo.addr02,
        company_name:userInfo.company_name,
        department_name:userInfo.company_name,
        name01:userInfo.name01,
        name02:userInfo.name02,
      };

      priceData.productList[0].totalPrice = priceData.totalPrice;
      priceData.productList[0].delivPrice = priceData.delivPrice;
      priceData.productList[0].productPrice = priceData.productPrice;
      priceData.productList[0].taxPrice = priceData.taxPrice;
      priceData.productList[0].discount = priceData.discount;
      estimatesData.issueDate = this.$common.getDateStringFromDate(new Date());

      this.$store.commit("hideLoading");
      this.$store.commit("showEstimates", estimatesData);
    },
    async clickOrderBtn(){
      if (!this.$store.state.isSignature) {
        this.$store.commit("showResendContractDialog");
        this.$store.commit("showMessage", "契約書へのサインが完了していません");
        return;
      }

      await this.orderProcess();
    },

    async orderProcess(bikou = "") {
      this.$store.commit("showLoading");

      //this.$store.commit("showProgress", true);
      this.$store.commit("setProgress", 0);
      this.$store.commit("setSendBytes", 0);

      this.$store.commit("setProgressMessages", [
        "しばらくお待ちください",
      ]);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        //this.$store.commit("hideLoading");
        this.$store.commit("hideProgress");
        this.$store.commit("showMessage", "エラーが発生しました");
      });

      // 一応金額を再計算

      let productData = []; // API送信時に使用
      let marginTotal = 0;
      let marginTotalIncTax = 0;
      //let priceTotal = 0;
      //let taxTotal = 0;

      // let progressPlus = (95 / this.$store.state.products.length).toFixed();
      // let prog = 0;
      //let totalSendBytes = 0;

      let quantityTotal = 0; // 注文時間の推測に使用

      // 受注用データ作成
      const TicketOrderData = this.getCouponOrderData(
        this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
        this.$store.state.acrylicTicketCouponManager.orderData.count );
      productData.push(TicketOrderData);

      if( !this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee ){
        // 送料企業負担
        const PostageOrderData = this.getAcryTicketPostageOrderData(
          this.$store.state.acrylicTicketCouponManager.orderData.count );
        productData.push(PostageOrderData);
      }

      quantityTotal += parseInt(this.$store.state.cartManager.cartList.length);

      this.$store.commit("setProgress", 3);

      let priceData = this.createProductPriceData();

      let delivTax = Math.ceil(priceData.delivPrice * this.$common.getTax());

      let data = {
        //deliv_check: this.destinationList[this.selectedDestination].other_deliv_id,
        fee_base: "0",
        fee_tax_rate: "0",
        fee_tax: "0",
        fee: "0",
        // 送料(税抜き)
        deliv_fee_base: priceData.delivPrice,
        // 送料税率
        deliv_fee_tax_rate: (this.$common.getTax() * 100).toFixed(),
        // 送料税額
        deliv_fee_tax: delivTax,
        // 送料税込
        deliv_fee: priceData.delivPrice + delivTax,
        // マージン率
        margin_rate: User.userData.introduced_margin,
        // マージン額合計(税抜き)
        margin_total: marginTotal,
        // マージン額合計(税込み)
        margin_total_inctax: marginTotalIncTax,
        // 商品代金税込マージン込み
        subtotal:
          priceData.productPrice +
          Math.ceil(priceData.productPrice * this.$common.getTax()),
        // 合計税額 送料分の税額は省く
        tax: priceData.taxPrice - delivTax,
        payment_total: priceData.totalPrice,
        discount: priceData.discount,
        message: bikou ? bikou : "",


        // クーポンに関する情報
        isSample: (this.$store.state.acrylicTicketCouponManager.orderData.isSample)?1:0,
        count: this.$store.state.acrylicTicketCouponManager.orderData.count,  // 作成数
        acrylicTicketSetting: this.$store.state.acrylicTicketCouponManager.orderData.acrylicTicketSettingDocId,  // デザイン
        couponProductId: this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,  // 作成数
        fromDate: this.$store.state.acrylicTicketCouponManager.orderData.fromDate,  // 作成数
        toDate: this.$store.state.acrylicTicketCouponManager.orderData.toDate,  // 作成数
      };
      this.$common.log(data);

      this.$store.commit("setProgress", 3);

      const TotalTime = 0.34 * quantityTotal;
      let oneSecondProgress = (99 - 3) / TotalTime;
      let progress = 3.0;

      // console.log(quantityTotal);
      // console.log(TotalTime);
      // console.log(oneSecondProgress);

      let timer = setInterval(
        function () {
          progress += oneSecondProgress;

          if (99 < parseInt(progress)) {
            this.$store.commit("setProgress", 99);
          } else {
            this.$store.commit("setProgress", parseInt(progress));
          }
        }.bind(this),
        1000
      );

      // 注文APIを実行
      User.orderCoupon(productData, data, PaymentType.CREDIT)
        .then((result) => {
          clearInterval(timer);

          // 注文履歴に登録
          // firestore
          this.$store.state.orderHistoryManager
            .registOrderHistoryDataForTicket(result.order_id, [{
              productId: this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
              quantity: this.$store.state.acrylicTicketCouponManager.orderData.count,
              acrylicTicketSetting: this.$store.state.acrylicTicketCouponManager.orderData.acrylicTicketSettingDocId,
              previewUrl: this.$store.state.acrylicTicketCouponManager.orderData.preview,
            }])
            .then(() => {
              // 注文完了
              this.$store.commit("setProgress", 100);
              //this.$store.commit("hideLoading");
              this.$store.commit("hideProgress");
              result.payment_total = data.payment_total;

              this.$store.commit("hideLoading");
              this.$store.commit("showCardPayment", {
                price: priceData.totalPrice,
                orderId: result.order_id,
              });

              // 決済完了後の処理を登録
              this.$store.commit("setCardPaymentCallback", ()=>{

                const OrderData = this.$store.state.acrylicTicketCouponManager.orderData;
                Analytics.acryTicketIssueTicket(OrderData.count, GetAcryProductSizeText(OrderData.ticketProductId), OrderData.isUserEdit, OrderData.isShippingFee);
                Analytics.purchase(result.order_id, data, productData);

                // 購入後のモーダルを表示
                this.isModal = true;
                // this.$store.commit("setCenterViewState", CenterViewState.SampleUpload);
              });
            })
            .catch((error) => {
              this.$common.log(error);
              this.$store.commit("hideProgress");
              this.$store.commit("showMessage", "エラーが発生しました");
            });
        })
        .catch((error) => {
          clearInterval(timer);
          this.$common.log(error);
          this.$store.commit("hideProgress");
          this.$store.commit("showMessage", "エラーが発生しました");
        });
    },
    getCouponOrderData(productId, quantity) {
      const priceData = GetAcryProductPrice(productId);
      let couponData = this.$store.state.saleProductManager.getProduct(productId);

      let data = {
        product_id: productId,
        product_name: couponData.productName,
        product_info: "front",
        front_image_path: "",
        front_image_path_mono: "",
        front_image_path_preview: "",
        front_image_path_outline: "",
        back_image_path: "",
        back_image_path_mono: "",
        back_image_path_preview: "",
        front_rib: "0",
        back_rib: "0",
        tag_type: "0",
        tag_image_path: "",
        tag_image_path_mono: "",
        product_price: priceData.priceBase,
        // 前面印刷価格
        paint_price_1: "0",
        // 後面印刷価格
        paint_price_2: "0",
        // タグ価格
        tag_price: "0",
        // 数量
        quantity: quantity,
        // マージン抜きの商品価格(税抜き)
        price_base: priceData.priceBase,
        // マージン額税抜き
        margin: "0",
        // マージン額税込
        margin_inctax: "0",
        // 税率(%)
        tax_rate: (Common.getTax() * 100).toFixed(),
        // 税額
        tax: Math.ceil(priceData.priceBase * Common.getTax()),
        // マージン込みの商品代金(税抜き)
        price: priceData.priceBase,
        // マージン込みの商品代金(税込)
        price_inctax: AcryShippingFee,
        product_class_id: Number(couponData.productData["product_class_list2"][0].product_class_id),
        classcategory_id1: 0,
        classcategory_id2: 0,
      };
      return data;
    },
    getAcryTicketPostageOrderData(quantity) {
      let productData = this.$store.state.saleProductManager.getProduct(ProductId.ACRY_TICKET_POSTAGE);

      let data = {
        product_id: ProductId.ACRY_TICKET_POSTAGE,
        product_name: productData.productName,
        product_info: "front",
        front_image_path: "",
        front_image_path_mono: "",
        front_image_path_preview: "",
        front_image_path_outline: "",
        back_image_path: "",
        back_image_path_mono: "",
        back_image_path_preview: "",
        front_rib: "0",
        back_rib: "0",
        tag_type: "0",
        tag_image_path: "",
        tag_image_path_mono: "",
        product_price: AcryShippingFeeBase,
        // 前面印刷価格
        paint_price_1: "0",
        // 後面印刷価格
        paint_price_2: "0",
        // タグ価格
        tag_price: "0",
        // 数量
        quantity: quantity,
        // マージン抜きの商品価格(税抜き)
        price_base: AcryShippingFeeBase,
        // マージン額税抜き
        margin: "0",
        // マージン額税込
        margin_inctax: "0",
        // 税率(%)
        tax_rate: (Common.getTax() * 100).toFixed(),
        // 税額
        tax: Math.ceil(AcryShippingFeeBase * Common.getTax()),
        // マージン込みの商品代金(税抜き)
        price: AcryShippingFeeBase,
        // マージン込みの商品代金(税込)
        price_inctax: AcryShippingFee,
        product_class_id: Number(productData.productData["product_class_list2"][0].product_class_id),
        classcategory_id1: 0,
        classcategory_id2: 0,
      };
      return data;
    },
    // カート内の商品価格の計算を行う
    createProductPriceData() {
      let productPriceData = {};
      productPriceData.productList = [];
      productPriceData.totalPrice = 0; // 払うべき金額 送料 + 商品合計 + 消費税合計 - 割引額
      productPriceData.delivPrice = 0; // 送料 (税別)
      productPriceData.productPrice = 0; // 商品合計 (税別)
      productPriceData.taxPrice = 0; // 消費税合計
      productPriceData.discount = 0; // アクリル商品の割引額 (税込)

      const orderPrice = CalculationTicketOrderPrice(
        this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
        this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee,
        this.$store.state.acrylicTicketCouponManager.orderData.count,
        this.$store.state.acrylicTicketCouponManager.orderData.isSample
      );

      this.ticketPrice = orderPrice.ticketPrice;
      this.discount = orderPrice.discount;
      this.delivPrice = orderPrice.delivPrice;
      this.totalTax = orderPrice.totalTax;
      this.totalPrice = orderPrice.totalPrice;

      {
        // チケット商品
        let product = {};
        const priceData = GetAcryProductPrice(this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId);
        const saleProduct = this.$store.state.saleProductManager.getProduct(this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId);
        product.title = saleProduct.productName;
        product.price = priceData.priceBase;
        product.tax = Math.floor(priceData.priceBase * Common.getTax());
        product.quantity = this.$store.state.acrylicTicketCouponManager.orderData.count;
        // product.discount = Math.floor((product.price) *
        //   product.quantity *
        //   (DiscountRatio(this.$store.state.acrylicTicketCouponManager.orderData.count) / 100));
        product.discount = 0;
        product.getProductTitle = function () {
          return "title";
        };
        productPriceData.productList.push(product);
        productPriceData.productPrice += product.price * product.quantity;
        productPriceData.taxPrice += product.tax * product.quantity;
        // productPriceData.discount += product.discount;
        // productPriceData.totalPrice += (product.price + product.tax) * product.quantity;
      }

      if( !this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee &&
        !this.$store.state.acrylicTicketCouponManager.orderData.isSample
       ){
        // 送料
        let product = {};
        const saleProduct = this.$store.state.saleProductManager.getProduct(ProductId.ACRY_TICKET_POSTAGE);
        product.title = saleProduct.productName;
        product.price = AcryShippingFeeBase;
        product.tax = Math.floor(AcryShippingFeeBase * Common.getTax());
        product.quantity = this.$store.state.acrylicTicketCouponManager.orderData.count;
        product.getProductTitle = function () {
          return "title";
        };
        productPriceData.productList.push(product);
        productPriceData.productPrice += product.price * product.quantity;
        productPriceData.taxPrice += product.tax * product.quantity;
        // productPriceData.totalPrice += (product.price + product.tax) * product.quantity;
      }

      // コード発行なので送料はかからない
      productPriceData.delivPrice = 0;
      productPriceData.taxPrice += productPriceData.delivPrice * Common.getTax();
      // productPriceData.totalPrice += productPriceData.delivPrice * (Common.getTax() + 1);

      // 割引分を引く
      // productPriceData.totalPrice -= productPriceData.discount;

      // 最終金額
      // productPriceData.taxPrice = Math.floor(productPriceData.taxPrice);
      // productPriceData.totalPrice = Math.floor(productPriceData.totalPrice);

      // 価格情報を設定
      productPriceData.discount = orderPrice.discount;
      productPriceData.taxPrice = orderPrice.totalTax;
      productPriceData.totalPrice = orderPrice.totalPrice;

      return productPriceData;
    },
    onClickTicketList(){
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },

    onClickIssueHistory(){
      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueHistory);
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.event-cell{
  gap: 24px;
  height: 186px;
  padding: 16px;
  border-bottom: solid 1px $border-sub-color;
  &:last-child { border-bottom: none; } // 最終行だけいらない
}

.acry-btn-sub {
  // margin: 10px;
  padding: 3px 30px;
  color: $primary-main-color;
  background-color: #ffffff;
  border: solid 2px $border-main-color;
  border-radius: 15px;
  font-size: 15px;
}
</style>


